export default "__VITE_ASSET__ijjC46It__"